// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1hbFl","footer":"ModalError_footer__2Y6aa"};